import { getQueryParam } from './query'
import { serverData } from './server-data'
import { logActivityWithLastImpression } from './fpti'
import { safeStringify } from 'universal'
import { WEBVIEW_CALLBACK_NAMES_BY_FLOWS } from 'universal/ucs'

const VeniceHandlerName = {
  home: 'home',
  close: 'close',
}

const LEGACY_WEBVIEW_CALLBACK_NAMES = {
  ON_ACTIVATION_SUCCESS_INIT: 'paypalCardActivationCompletionHandler',
}

const COMMON_WEBVIEW_CALLBACK_NAMES = {
  UCS_FLOW_ERROR: 'onUCSFlowError',
}

const WEBVIEW_CALLBACK_NAMES = {
  ...WEBVIEW_CALLBACK_NAMES_BY_FLOWS,
  ...COMMON_WEBVIEW_CALLBACK_NAMES,
}

function shouldTriggerVeniceCallback() {
  const webviewCallback = getQueryParam('webviewCallback')
  return serverData.isMobileNative && !!webviewCallback
}

function triggerVeniceCallback(handlerName, webviewPayload) {
  const stringifiedPayload = webviewPayload ? safeStringify(webviewPayload) : ''

  logActivityWithLastImpression(`veniceCallback:${handlerName}`, {
    message: `${stringifiedPayload}`,
  })

  const hasVeniceHandler = window.venice && window.venice[handlerName]
  if (hasVeniceHandler) {
    if (stringifiedPayload) {
      window.venice[handlerName](stringifiedPayload)
      return true
    }
    window.venice[handlerName]()
    return true
  }

  return false
}

function isMobileNative() {
  return serverData.isMobileNative
}

export {
  VeniceHandlerName,
  LEGACY_WEBVIEW_CALLBACK_NAMES,
  WEBVIEW_CALLBACK_NAMES,
  shouldTriggerVeniceCallback,
  triggerVeniceCallback,
  isMobileNative,
}
